// BM-H3394 (1 Oct 2026): the default body of the "Please sign your Client
// Care Letter" email, the covering email that carries the CCL and the care
// pack. Vanessa: the CCL asks for money on account and the covering email
// repeats it. The request is driven by the FORF answer "Payment on account
// required" (Q17) and its amount (Q17_amount), the same answers the letter
// itself uses, so the two cannot disagree. The FORF amount is the legal fees
// before VAT (Vanessa, 1 Oct 2026); the letter itself shows the gross total.
//
// Open punctuation in the default copy: "Dear X" (no comma), "Yours
// sincerely" (no full stop). Vanessa's house style.

function forfAnswers(submissionData) {
  return (submissionData && submissionData.data) || submissionData || {};
}

// The FORF figure as pence, or null when blank or unreadable. The figure is
// before VAT; any VAT wording typed alongside it is ignored.
function netPence(raw) {
  const v = String(raw == null ? "" : raw)
    .replace(/\s*(?:plus|\+|inc\.?|incl\.?|including|excluding|ex)\s*vat\b/gi, "")
    .replace(/[£,\s]/g, "");
  if (!/^\d+(\.\d+)?$/.test(v)) return null;
  return Math.ceil(Number(v) * 100 - 1e-9);
}

// Mirrors backend hub/money.net_vat_gross: VAT at the catalogue rate
// (quoting_catalogue_v1.VAT_RATE, 20%), every figure rounded UP to the penny,
// so the email and the letter print the same total.
const VAT_PERCENT = 20;

function gbp(pence) {
  const text = (pence / 100).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `£${text.endsWith(".00") ? text.slice(0, -3) : text}`;
}

// The money on account paragraph, or "" when the FORF does not ask for one.
// Wording from the residential team's own MOA email (Emily, 1 Oct 2026).
export function moneyOnAccountLine(submissionData) {
  const data = forfAnswers(submissionData);
  if (String(data.Q17 || "").trim().toLowerCase() !== "yes") return "";
  const net = netPence(data.Q17_amount);
  const what = net == null
    ? "the payment on account set out in your Client Care Letter"
    : `${gbp(net + Math.ceil((net * VAT_PERCENT) / 100))} (${gbp(net)} plus VAT)`;
  return [
    `I would be grateful if you would place ${what} into our client account, details in your welcome pack, where this will be held until invoiced or returned to you. ` +
      "As previously instructed, this must only be paid into our account by the person or company that we have verified via the onboarding process.",
    "Please use the reference on your Client Care Letter when making payment.",
    "Please note that an invoice will not be issued for this payment. These funds are held in our client account and therefore belong to you until our work is completed, at which time an invoice will be provided which will be for our total fees less any amounts we hold in our client account.",
  ].join("\n");
}

export function defaultCoverBody(tradingName, submissionData) {
  const moa = moneyOnAccountLine(submissionData);
  return [
    "Please review and sign your Client Care Letter using the secure link below",
    "",
    "Once signed a copy is filed to your matter automatically",
    "",
    ...(moa ? [moa, ""] : []),
    "Yours sincerely",
    tradingName,
  ].join("\n");
}
